// extracted by mini-css-extract-plugin
module.exports = {"bookletContainer":"views-Booklet__bookletContainer--Mqja3"};